import VectorSource from "ol/source/Vector";
import Heatmap from 'ol/layer/Heatmap.js';


export const heatMap = ({ map, featureCollection, activeLayers, setActiveLayers }) => {
    const radiusSwiper = document.getElementById('radiusSwiper');
    const blurSwiper = document.getElementById('blurSwiper');

    let heatMapLayer;

    const radiusRenderHandle = () => {
        const radius = radiusSwiper.value;
        heatMapLayer.setRadius(parseInt(radius, 10));
        map.render();
    }

    const blurRenderHandle = () => {
        const blur = blurSwiper.value;
        heatMapLayer.setBlur(parseInt(blur, 10));
        map.render();
    }

    const mount = () => {
        if(activeLayers) {
            setActiveLayers();
        }

        const features = [];
    
        featureCollection.forEach(collection => {
            features.push(...collection.featureArray);
        });

        const source = new VectorSource({
            features: features
        });

        heatMapLayer = new Heatmap({
            source: source,
            radius: parseInt(radiusSwiper.value, 10),
            blur: parseInt(blurSwiper.value, 10),
        })

        radiusSwiper.addEventListener('input', radiusRenderHandle);
        blurSwiper.addEventListener('input', blurRenderHandle);

        setActiveLayers([heatMapLayer])
    }

    const dismount = () => {
        if(radiusSwiper && blurSwiper) {
            radiusSwiper.removeEventListener('input', radiusRenderHandle);
            blurSwiper.removeEventListener('input', blurRenderHandle);
        }

        setActiveLayers()
    }

    return { mount: mount, dismount: dismount };
}